module.exports = __webpack_public_path__ + "h5/img/strokes-10.218cf6ce.png";